/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import Tippy from '@tippyjs/react';
import * as React from 'react';
import {
  components as SelectComponents,
  GroupTypeBase,
  OptionTypeBase,
  SingleValueProps,
  StylesConfig,
} from 'react-select';

import { userSelectStyles } from './user';

export const CustomRepeatPeriodLabels = {
  week: (helpText = 'Week') => <Tippy content={helpText} />,
  month: (helpText = 'Month') => <Tippy content={helpText} />,
  year: (helpText = 'Year') => <Tippy content={helpText} />,
};

export const renderCustomRepeatPeriods = {
  week: CustomRepeatPeriodLabels.week(),
  month: CustomRepeatPeriodLabels.month(),
  year: CustomRepeatPeriodLabels.year(),
};

export const customRepeatPeriodOptions = [
  {
    label: 'Week',
    value: 'week',
  },
  {
    label: 'Month',
    value: 'month',
  },
  {
    label: 'Year',
    value: 'year',
  },
];

export const getCustomRepeatPeriodLabel = {
  week: 'Week',
  month: 'Month',
  year: 'Year',
};

type OptionType = OptionTypeBase & { label: string; value: string };
type GroupType = GroupTypeBase<OptionType>;

export const customRepeatPeriodSelectStyles: StylesConfig<OptionType, boolean, GroupType> = {
  ...userSelectStyles,
  menuPortal: (base) => ({ ...base, zIndex: 1600 }),
  option: (styles, { isDisabled, isFocused, isSelected }) => ({
    ...styles,
    ...(userSelectStyles?.option
      ? userSelectStyles?.option(styles, {
          isDisabled: isDisabled,
          isFocused: isFocused,
          isSelected: isSelected,
        } as any)
      : {}),

    padding: '1.3rem 1.5rem 1.3rem 1rem',
  }),
};

export const CustomRepeatPeriodSelectSingleValue:
  | React.ComponentType<SingleValueProps<OptionType, GroupType>>
  | undefined = (props) => (
  <div className="flex items-center">
    <span className="ml-8">{props.data.label}</span>
  </div>
);

export const CustomRepeatPeriodSelectOption: any = (props) => (
  <SelectComponents.Option {...props}>
    <div className="flex items-center">
      <span className="ml-8">{props.data.label}</span>
    </div>
  </SelectComponents.Option>
);
